import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List, Icon, Popconfirm } from 'antd'

import moment from 'moment'

@inject((store: any) => {
    const { popupStore, servicefieldsStore } = store
    return { popupStore, servicefieldsStore }
})
@observer
export default class Servicefield extends Component<any, any> {
    state: any = {
        errors: {}
    }

    handleSubmit = async () => {
        const { editServicefield, addServicefield, updateServicefield } = this.props.servicefieldsStore
        if (editServicefield.id === 'add') {
            await addServicefield()
        } else {
            await updateServicefield()
        }
    }

    render() {
        const { servicefield } = this.props
        const {
            error,
            editServicefield,
            toggleServicefield,
            editValue,
            resetEdit,
            deleteServicefield
        } = this.props.servicefieldsStore
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: '0.7rem 0.5rem',
                    backgroundColor: `${editServicefield.id === servicefield.id ? '#f0f2f5' : 'initial'}`
                }}
            >
                <div
                    style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}
                    onClick={() => toggleServicefield(servicefield)}
                >
                    {servicefield.id === 'add' ? (
                        <div
                            style={{
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                color: '#e77910',
                                textDecoration: 'underline',
                                width: '100%'
                            }}
                        >
                            <Icon type={editServicefield.id === 'add' ? 'down' : 'left'} />
                            <span style={{ marginRight: '0.5rem' }}>הוסף תחום שירות חדש +</span>
                        </div>
                    ) : (
                        <Fragment>
                            <div>
                                <span style={{ marginLeft: '0.5rem' }}>
                                    <Icon type={editServicefield.id === servicefield.id ? 'down' : 'left'} />
                                </span>
                                {servicefield['id']} - {servicefield['name']} (
                                {servicefield['__meta__']['related_collections']} זכויות)
                            </div>
                            <div>
                                {servicefield['updated_by'] ? servicefield['updated_by'] : 'כל הבריאות'}
                                {servicefield['updated_at']
                                    ? ` | ${moment(servicefield['updated_at']).format('DD/MM/YYYY')}`
                                    : ''}
                            </div>
                        </Fragment>
                    )}
                </div>
                {editServicefield.id === servicefield.id ? (
                    <div style={{ padding: '0.5rem 0.2rem 0.2rem', display: 'flex', flexDirection: 'column' }}>
                        {servicefield['updated_by'] || servicefield.id === 'add' ? (
                            <Fragment>
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <Input
                                        value={editServicefield.name}
                                        placeholder="הזן שם תחום שירות"
                                        onChange={e => editValue('name', e.target.value)}
                                    />
                                    <Button
                                        disabled={!editServicefield.name || editServicefield.name === servicefield.name}
                                        style={{ margin: '0 0.2rem' }}
                                        onClick={() => resetEdit()}
                                    >
                                        <Icon type="stop" />
                                    </Button>
                                    <Popconfirm
                                        disabled={!editServicefield.name || editServicefield.name === servicefield.name}
                                        onConfirm={() => this.handleSubmit()}
                                        okText="אישור"
                                        cancelText="ביטול"
                                        title={`האם ${editServicefield.id === 'add' ? 'להוסיף' : 'לעדכן'} תחום זה?`}
                                    >
                                        <Button
                                            style={{ margin: '0' }}
                                            disabled={
                                                !editServicefield.name || editServicefield.name === servicefield.name
                                            }
                                            type="primary"
                                        >
                                            <Icon type="check" />
                                        </Button>
                                    </Popconfirm>
                                </div>
                                <div>
                                    {servicefield['updated_by'] ? (
                                        <Popconfirm
                                            onConfirm={() => deleteServicefield()}
                                            okText="אישור"
                                            cancelText="ביטול"
                                            title={`הסרת תחום זה תסיר את הקשר בין התחום לזכויות האם בכל זאת למחוק זה?`}
                                        >
                                            <Icon type="delete" />
                                            <a style={{ textDecoration: 'underline' }}>הסר תחום שירות</a>
                                        </Popconfirm>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </Fragment>
                        ) : (
                            <span>תחום שירות זה הורד במקור מאתר כל הבריאות ולא ניתן לעריכה</span>
                        )}
                        {error ? <span style={{ color: 'red', fontWeight: 'bold' }}>{error}</span> : ''}
                    </div>
                ) : (
                    ''
                )}
            </div>
        )
    }
}
